import { createFileRoute } from '@tanstack/react-router';

import { useAuth } from '@/store/auth.ts';
import { CalendarPageView } from '@/views/calendar/calendar-page-view.tsx';

// 跨课程日程（ADR-020）：聚合所有已选/所教课程的截止日期 +
// quiz 时间窗口 + 课程/个人事件（服务器端角色感知），
// 加上 iCal 订阅卡片 + 个人事件 CRUD。
export const Route = createFileRoute('/_learner/calendar')({
  component: CalendarPage,
});

function CalendarPage() {
  const user = useAuth((s) => s.user);
  if (!user) return null;
  return <CalendarPageView user={user} />;
}
